import {ApiClientFactory, ApiClientFactoryInterface} from "./clients";
import {Headers} from "../types";
import {OfferPurchaseManager} from "../OfferPurchaseManager";

export class OfferPurchaseManagerFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(
      `${baseUrl}/api/v1/offer`,
      headers
    );
  }

  public createOfferPurchaseManager(token: string): OfferPurchaseManager {
    return new OfferPurchaseManager(this.apiClientFactory.createAuthorizedClient(token));
  }
}